var map = {
	"./dark/my/02medal/01down.svg": "9my1",
	"./light/my/02medal/01down.svg": "hp+W"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s6tw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/my\/02medal\/01down\.svg$
// module id = s6tw
// module chunks = 0